<template>
  <div>
    <transition name="modal">
      <div class="container">
        <div class="overlay">
          <div class="webcam_modal">
              <div class="row">
                  <div class="col-md-12">
                      <h5>Face Recognition Required!</h5>
                      <p>This course requires identification of your self, for that we need to take a capture of your face. So face the camera properly and click Capture now button below to continue with your lesson.</p>
                      <div v-if="showCamera" class="cam-section">
                        <code class="device-code" v-if="device">{{ device.label }}</code>
                        <form action="" id="capture"></form>
                          <vue-web-cam
                              ref="webcam"
                              :device-id="deviceId"
                              height="350"
                              @started="onStarted"
                              @stopped="onStopped"
                              @error="onError"
                              @cameras="onCameras"
                          />
                                <select v-model="camera" class="device-selection">
                                  <option>-- Select Device --</option>
                                  <option
                                      v-for="device in devices"
                                      :key="device.deviceId"
                                      :value="device.deviceId"
                                  >{{ device.label }}</option>
                                </select>
                      </div>
                      <figure class="figure">
                          <img :src="img" class="img-responsive" />
                      </figure>

                      <div class="row">
                          <div class="col-md-12">
                              <button type="button" class="btn btn-primary" @click="onCapture" :disabled="disableCapture">
                                <img src="/media/icons/camera.png" />
                                Capture
                              </button>
                              <!-- <button type="button" class="btn btn-danger" @click="onStop">Stop Camera</button>
                              <button type="button" class="btn btn-success" @click="onStart">Start Camera</button> -->
                          </div>
                      </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import { WebCam } from 'vue-web-cam'
var $ = require('jquery')
var Cookies = require('vue-cookies')
var Config = require('../../router/Config')
// var userPermissions = Cookies.get('userPermissions')

export default {
  name: 'webcam',
  components: {
    'vue-web-cam': WebCam
  },
  props: ['showWebcam', 'captureCount','captureMode'],
  data () {
    return {
      api_url: Config.API_URL,
      URL: '',
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      showCamera: true,
      disableCapture: true
    }
  },
  mounted () {
  },
  computed: {
    device: function () {
      return this.devices.find(n => n.deviceId === this.deviceId)
    }
  },
  beforeDestroy: function () {
  },
  watch: {
    camera: function (id) {
      this.deviceId = id
    },
    devices: function () {
      // Once we have a list select the first one
      this.devices.forEach(items => {
        this.camera = items.deviceId
        this.deviceId = items.deviceId
      })
    }
  },
  methods: {
    onCapture () {
      console.log('image capture count: ' + Cookies.get('captureCount'))
      this.img = this.$refs.webcam.capture()
      var formdata = new FormData($('#capture')[0])
      formdata.append('topic_id', Cookies.get('topicId'))
      formdata.append('course_id', Cookies.get('courseId'))
      formdata.append('user_id', Cookies.get('userId'))
      formdata.append('counter_number', Cookies.get('captureCount'))
      formdata.append('exam_id', Cookies.get('studentExamIdToStart'))
      formdata.append('base64image', this.img)
      if (this.captureMode === 'exam') {
        this.URL = '/api/fe/capture/exam-capture-store';
      } else {
        this.URL = '/api/fe/capture/store';
      }
      this.axios.post(this.api_url + this.URL + '?token=' + Cookies.get('accessToken'), formdata).then(response => {
        // console.log('capture image')
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error)
      })
      this.showCamera = false
      var self = this
      setTimeout(function () {
        self.$emit('showWebcam', false)
      }, 1000)
    },
    onStarted (stream) {
      this.disableCapture = false
      // console.log('On Started Event', stream)
    },
    onStopped (stream) {
      // console.log('On Stopped Event', stream)
    },
    onStop () {
      this.$refs.webcam.stop()
    },
    onStart () {
      this.$refs.webcam.start()
    },
    onError (error) {
      console.log('On Error Event', error)
    },
    onCameras (cameras) {
      this.devices = cameras
      // console.log('On Cameras Event', cameras)
    }
    // onCameraChange (deviceId) {
    //   this.deviceId = deviceId
    //   this.camera = deviceId
    //   console.log('On Camera Change Event', deviceId)
    // }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/component/modal/webcam";
</style>
